import { PlatformOrigin } from '@/types/platform'

export const LINK_TITLE_LOADING_EVENT = 'linkTitleLoading'

export const LINK_TITLE_PLATFORM_ORIGINS = [
  PlatformOrigin.bazaar,
  PlatformOrigin.cosmo,
  PlatformOrigin.esquire,
  PlatformOrigin.goodhouse,
  PlatformOrigin.grazia,
  PlatformOrigin.mhealth,
  PlatformOrigin.popmech,
  PlatformOrigin.robb,
  PlatformOrigin.girlspower,
  PlatformOrigin.arcan,
  PlatformOrigin.vslova,
]
